
import verifyLabel from '../../../../methods/verifyLabel'
import currencyFormatter from '../../../../methods/currencyFormatter'

export default {
    name: 'product-tile',
    data(){
        return {
            isCourse: false,
        }
    },
    props : {
        cardData : Object
    },
    computed:{
        logoPath() {
            var labelsObj = this.$store.state.main.labels
            var requestedLabel = "ProductTypeCourseLogoPath"

            var exists = Object
                .keys(labelsObj && typeof labelsObj === "object" ? labelsObj : {})
                .find(label => label === requestedLabel)
            
            if (!exists) return null;
            if (!(labelsObj[requestedLabel])) return null;

            return labelsObj[requestedLabel]
        },
        productTypeDisplayName() {
            if (this.cardData.productType === 'Hardware') {
                return verifyLabel("productTypeHardwareDisplayName", this.$store.state.main.labels)
            }
            if (this.cardData.productType === 'Software') {
                return verifyLabel("productTypeSoftwareDisplayName", this.$store.state.main.labels)
            }
            return verifyLabel("productTypeCourseDisplayName", this.$store.state.main.labels)

        },
        productTypeSelectLabel() {
            if (this.cardData.productType === 'Hardware') {
                return verifyLabel("selectHardwareLabel", this.$store.state.main.labels)
            }
            if (this.cardData.productType === 'Software') {
                return verifyLabel("selectProductLabel", this.$store.state.main.labels)
            }

            return verifyLabel("selectCourseLabel", this.$store.state.main.labels)
        },
        label() {
            return this.$store.state.main.labels
        },
        evalCardProductType() {
            if (this.cardData.productType === 'Course') {
                this.isCourse = true
            }
            return `nti-product-tile__image-wrapper__label-container--${this.cardData.productType}` 
        },
        formattedPrice() {
            if (!this.cardData.priceFrom) return "";
            return currencyFormatter(this.cardData.priceFrom.currencyCode, this.cardData.priceFrom.amount)
        },
        formattedDiscountedPrice() {
            if (!this.cardData.priceFrom) return "";
            return currencyFormatter(this.cardData.priceFrom.currencyCode, this.cardData.priceFrom.amountDiscounted)
        },
        discountedProduct() {
            if (!this.cardData.priceFrom) return "";
            return (this.cardData.priceFrom.amountDiscounted)
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName,this.$store.state.main.labels)
            } else {
                return ""
            }
        }
    }
}